export const ARCHITECTURE_ID_SEARCH_PARAM = 'architectureId';

export const VIEW_SEARCH_PARAM = 'view';

/** Set while the Level mapping flow takes the place of the Positions list. */
export const LEVEL_MAPPING_SEARCH_PARAM = 'level-mapping';

export const LEVEL_MAPPING_RUN_SEARCH_PARAM = 'level-mapping-run';

export const CREATE_ARCHITECTURE_SEARCH_PARAM = 'create';

export const CREATE_ARCHITECTURE_SEARCH_VALUE = '1';

export const JOB_ARCHITECTURE_ID_SEARCH_PARAM = 'jobArchitectureId';

export const LAYOUT_SEARCH_PARAM = 'tab';

export const POSITION_LAYOUTS = ['board', 'table', 'canvas'] as const;

export type PositionLayout = (typeof POSITION_LAYOUTS)[number];

export const ARRANGEMENT_SEARCH_PARAM = 'arrange';

export const POSITION_ARRANGEMENTS = ['structure', 'org-chart'] as const;

export type PositionArrangement = (typeof POSITION_ARRANGEMENTS)[number];

export const ORG_CHART_ROOT_SEARCH_PARAM = 'root';

export const CANVAS_PANE_SEARCH_PARAM = 'pane';

export const LINE_SEARCH_PARAM = 'line';
